import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BasicLayoutComponent } from './common/layouts/basicLayout.component';
import { BlankLayoutComponent } from './common/layouts/blankLayout.component';
import { HomeComponent } from './common/layouts/home/home.component';
import { LoginComponent } from './common/layouts/login/login.component';
import { AuthGuard, PrepareGuard } from './core/core.module';
import { JobsModule } from './jobs/jobs.module';
import { AdminModule } from './admin/admin.module';
import { TimeModule } from './time/time.module';
import { InvoicesModule } from './invoices/invoices.module';
import { InvoiceComponent } from './portal/invoice/invoice.component';
import { PortalModule } from './portal/portal.module';

export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: '',
        component: BasicLayoutComponent,
        children: [
            {
                path: 'home',
                component: HomeComponent,
                data: { title: 'Home' },
                canActivate: [AuthGuard, PrepareGuard]
            }
        ]
    },
    {
        path: '',
        component: BlankLayoutComponent,
        children: [
            {
                path: 'login',
                component: LoginComponent,
                data: { title: 'Login' }
            }
        ]
    },

    // Handle all other routes
    { path: '**', redirectTo: 'home' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {}), JobsModule, AdminModule, TimeModule, InvoicesModule, PortalModule],
    exports: [RouterModule]
})
export class AppRoutingModule {}
